import React from 'react';
import { Icon, ICONS } from '@ohif/ui';
import "./SuccessModal.css"
function SuccessModal({ handleCloseModal, title, isSuccessModalOpen }) {
  setTimeout(() => {
    handleCloseModal(); // Call your function to close the modal
  }, 1500)
  if (!isSuccessModalOpen) return null;

  return (

    <>
    <div className="successModal-overlay">
      <div className="success-modal">
        <Icon name="SuccessCircle" className="text-black cursor-pointer" />
        <p>{title}</p>
      </div>
    </div>
  </>
  )
}

export default SuccessModal;
